 <template>
  <div>
    <div>
      <top-menu 
        :backVisible="true"
        :homeVisible="true"
        :aboutVisible="false"
      >
      </top-menu>
    </div>
    <div>
      <v-container fluid class="ma-0 pa-0 mt-6">
        <v-row dense>
          <v-col class="ma-0 pa-0">
            <v-card v-for="(item, index) in aircraft" :key="index" flat class="ma-0 pa-0">
              <v-card-title class="title font-weight-bold justify-center ma-0 pa-0">
                <span class="blue--text text--darken-4">{{item.tailnumber}} ({{item.callsign}})</span>
              </v-card-title>
              <div class="text-center">
                <div class="text-left">
                  <v-card-text>
                    <v-layout class="justify-center blue darken-4">
                      <div class="blue darken-4"><label><span class="font-weight-bold white--text">AMRAD Info</span></label></div>
                    </v-layout>
                    <br />
                    <div ><label><span class="font-weight-bold">Aircaft Status: </span>{{mx_status[index].AircraftStatus}}</label><br /></div>
                    <div ><label>
                      <span class="font-weight-bold">Mission Status: </span>{{mx_status[index].MissionStatus}}
                      <v-icon :color="getACStatusIconColor(index)">mdi-airplane</v-icon>
                    </label><br /></div>
                    <div ><label><span class="font-weight-bold">Limitations: </span>{{mx_status[index].LimitationStatus}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">Location: </span>{{mx_status[index].Location}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">Mx Facility: </span>{{mx_status[index].Facility}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">Tach Time: </span>{{mx_status[index].Tach}}</label><br /></div>
                    <br />

                    <v-layout class="justify-center blue darken-4">
                      <div><label><span class="font-weight-bold white--text">Weight/Balance</span></label></div>
                    </v-layout>
                    <br />
                    <div ><label><span class="font-weight-bold">Max Gross Weight: </span>{{item.mgw}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">Empty Weight: </span>{{item.emptyweight}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">Moment: </span>{{item.moment}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">CG/ARM: </span>{{item.cg_arm}}</label><br /></div>
                    <br>
                    <div v-if="item.foreflightwbprofile != null"  class="text-center">

                      <v-btn class="mx-2" fab dark small color="blue-grey darken-1" @click="openUrl(item.foreflightwbprofile)">
                        <v-icon dark>mdi-shield-airplane</v-icon>
                      </v-btn>
                      <div class="mt-2">
                      <label>ForeFlight Profile</label>
                      </div>
                      <br />
                    </div>

                    <v-layout class="justify-center blue darken-4">
                      <div class="blue darken-4"><label><span class="font-weight-bold white--text">Aircraft Data</span></label></div>
                    </v-layout>
                    <br />
                    <div ><label><span class="font-weight-bold">Year: </span>{{item.year}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">Model: </span>{{item.model}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">Serial: </span>{{item.serial}}</label><br /></div>
                    <br>
                    <div ><label><span class="font-weight-bold">Turbo: </span>{{item.turbo ? 'Yes':'No'}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">12 Volt Power Location: </span>{{item.power12volt}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">DF Equipment: </span>{{item.directionfinder}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">GPS Type: </span>{{item.gps}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">ADSB Approved: </span>{{item.adsb}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">CAP FM Radio Type: </span>{{item.capfm}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">VIRB Mount Type: </span>{{item.virbmount}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">Camera Window Location: </span>{{item.camerawindow}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">PA Warning System (APAWS): </span>{{item.apaws ? 'Yes':'No'}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">Auto Pilot Type: </span>{{item.autopilot}}</label><br /></div>
                    <div ><label><span class="font-weight-bold">Engine Analyzer Type: </span>{{item.enganalyzer}}</label><br /></div>
                    <br />

                    <v-layout class="justify-center blue darken-4">
                      <div class="blue darken-4"><label><span class="font-weight-bold white--text">Maintenance Officer(s)</span>&nbsp;</label></div>
                    </v-layout>
                    <br />
                    <div v-for="(contact,idx) in staff" :key="idx">
                      <div ><span class="font-weight-bold">Name: </span><label>{{contact.contact}} {{contact.assistant ? '(Asst)':''}}</label></div>
                      <div v-if="contact.homephone != null"><span class="font-weight-bold">Home Phone: </span><label> {{contact.homephone.slice(0,3) + '-' + contact.homephone.slice(3, 6) + '-' + contact.homephone.slice(6)}}</label><br /></div>
                      <div v-if="contact.cellphone != null"><span class="font-weight-bold">Cell Phone: </span><label> {{contact.cellphone.slice(0,3) + '-' + contact.cellphone.slice(3, 6) + '-' + contact.cellphone.slice(6)}}</label><br /></div>
                      <br />
                      <div class="text-center">
                          <v-btn v-if="contact.homephone != null" class="mx-2" fab dark small color="blue darken-4" :href="`tel:+1${contact.homephone}`">
                            <v-icon dark>mdi-phone</v-icon>
                          </v-btn>
                          <v-btn v-if="contact.cellphone != null" class="mx-2" fab dark small color="green darken-4" :href="`tel:+1${contact.cellphone}`">
                            <v-icon dark>mdi-cellphone</v-icon>
                          </v-btn>
                          <v-btn class="mx-2" fab dark small color="orange darken-4" :href="`mailto:${contact.email}`">
                            <v-icon dark>mdi-email</v-icon>
                          </v-btn>
                      </div>
                      <br />
                      <v-divider :key="contact.capid"></v-divider><br />
                    </div>
                  </v-card-text>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </div>

    <!-- Begin - Loading Data Modal -->
    <v-dialog
      v-model="isLoading"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          Loading Data...
          <v-progress-linear
            indeterminate
            rounded
            color="white"
            class="mb-0"
            height="20px"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- End - Loading Data Modal -->

  </div>    
</template>

<script>
export default {
  name: 'AircraftDetail',
  props: {
    TailNumber: {
      type: String,
      default: null
    }
  },
  components: {
  },
  data() {
    return {
      isLoading: true,
      aircraft: [],
      mx_colors: {
        "Full Mission Capable" : "#00CC00",
        "Partial Mission Capable": "#CCCC00",
        "Not Mission Capable": "#CC0000"
      },
      mx_status: [],
      staff: []
    }
  },
  mounted() {
    this.getData();
    this.setBackButtonVisibility(true);
    this.setHomeButtonVisibility(true);
  },
  methods: {
    openUrl(url) {
      var winObj = window.open(url, '_blank');
      //var winObj = window.open(url);
      //window.open(url);
      winObj.close();
    },
    getData() {

    this.isLoading = true;

    const result = this.lookupAircraft.filter(item => (item.tailnumber == this.TailNumber));
    this.aircraft = result;
    this.mx_status = this.lookupAircraftMx.filter(item => (item.TailNo == this.TailNumber));

    var obj = {
      wing: this.selWing,
      orgid: result[0].orgid,
      duty: "Maintenance Officer"
    }
    this.$https.post(this.$vars.BaseUrl + this.$vars.GetStaffForUnitDutyPositionRoute, obj, this.$vars.config)
      .then(response => {
        //console.log(response);
        this.httpResponse = response;
        this.staff = response.data;
        this.isLoading = false;
      })
      .catch(e => {
        //console.log(e);
        this.httpResponse = e;
        this.isLoading = false;
      });
    },
    getACStatusIconColor(index) {
      try{
        return this.mx_colors[this.mx_status[index].MissionStatus];
      }
      catch(e) {
        return "#333333";
      }
    },
  }
}
</script>

<style>

</style>
